import React, { forwardRef, lazy, Suspense } from 'react';
const OriginalDatePicker = lazy(() => import('react-datepicker'));

import type { ReactDatePickerProps } from 'react-datepicker';

import { AnyType } from '@src/models/common';

export const DefaultDatePicker = forwardRef<
  AnyType,
  Omit<ReactDatePickerProps, 'selectsRange'> & { selectsRange?: boolean }
>((props, ref) => {
  const { dateFormat, selected, onChange, onFocus, onBlur, placeholderText, ...rest } = props;

  return (
    <Suspense>
      <OriginalDatePicker
        {...rest}
        placeholderText={placeholderText}
        ref={ref}
        locale={'ru'}
        dateFormat={dateFormat}
        timeInputLabel={'Время'}
        selected={selected}
        onChange={onChange}
        autoComplete="off"
        onFocus={onFocus}
        onBlur={onBlur}
      />
    </Suspense>
  );
});

DefaultDatePicker.displayName = 'DefaultDatePicker';
